module.exports = __webpack_public_path__ + "img/icon_situation_public-holiday.ef3bd1a.svg";